import React, { Component } from "react";
import styles from "./StatBar.module.scss";



const renderStats = (array = []) => {

	return array.map((item, i) => {
		function createMarkup() {
			return {
				__html: item.description.content.html
			};
		}
		return (
			<div key={"stat-" + i} className="col-12 col-md-4 text-center">
				<b className={styles.stat}>{item.title}</b>
				<p className={styles.description}>{item.text}</p>
				<div className={styles.description} dangerouslySetInnerHTML={createMarkup()} />
			</div>
		);
	});
};

class StatBar extends Component {
	render() {
		return (
			<div className={styles.stat_bar}>
				<div className="container">
					<div className={"row " + styles.stat_row}>
						{renderStats(this.props.stats)}
					</div>
				</div>
			</div>
		);
	}
}

export default StatBar;



// WEBPACK FOOTER //
// ./src/components/StatBar/index.js